import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Card,
  TextField,
  Button,
  Chip,
  Container,
  Grid,
  CircularProgress,
  Backdrop,
  Stack,
  Toolbar,
  AppBar,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import api from "../services/api";
import ShortlistDetailsForm from "./ShortlistDetailsForm";

export default function JDWithL0() {
  const { token } = useParams();
  console.log("token", token)
  const [openDialog, setOpenDialog] = useState(false);
  const [dialog, setDialog] = useState({
      open: false,
      title: "",
      message: "",
    });
  
  const [availability, setAvailability] = useState({
        date: "",
        time: "",
    });
  const [jd, setJd] = useState(null);
  const [skipping, setSkipping] = useState(null);
  const [resumeId, setResumeId] = useState(null);
  const [jdId, setJdId] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    if (!token) return;

    const resolveToken = async () => {
      console.log("Started---------------------")
      try {
        const res = await api.get(`/resolve-token/${token}/`);
        setResumeId(res.data.resume_id);
        setJdId(res.data.jd_id);
      } catch {
        setDialog({
        open: true,
        title: "Invalid Job Link",
        message: "This job link is no longer valid or has expired.",
      })
      }
    };

    resolveToken();
  }, [token]);

  useEffect(() => {
    if (!jdId) return;

    const loadJob = async () => {
      try {
        const res = await api.get(`/career/job-detail/${jdId}/`);
        setJd(res.data);
      } catch {
        setDialog({
        open: true,
        title: "Invalid Job Link",
        message: "This job link is no longer valid or has expired.",
      })
      }
    };

    loadJob();
  }, [jdId]);

  useEffect(() => {
    if (!resumeId || !jdId) return;

    const value = `${resumeId}_${jdId}`;

    api.get(`/shortlist-details/${value}/`)
      .then(res => setSkipping(res.data))
      .catch(console.error);
  }, [resumeId, jdId]);

  const handleScheduleClick = () => {
      setOpenDialog(true);
    };
  
    const handleClose = () => {
      setOpenDialog(false);
    };
  
    const handleSubmitAvailability = () => {
      api.post("/candidate-availability/", {
        token,
        date: availability.date,
        time: availability.time,
      })
      .then(() => {
        setDialog({
          open: true,
          title: "Success",
          message: "Availability submitted successfully!",
        })
        setOpenDialog(false);
      })
      .catch(err => {
        console.error(err);
        setDialog({
          open: true,
          title: "Error",
          message: "Something went wrong",
        })
      });
    };

    const handleStartNow = () => {
        window.open(`${api.interview_link}/interview_welcome?jd_id=${jdId}&resume_id=${resumeId}`);
    };

    const formatWithFallback = (value, fallback) => {
      if (!value) return { text: fallback, dim: true };

      const v = value.toLowerCase();
      if (v.includes("not specified") || v === "n/a") {
        return { text: fallback, dim: true };
      }

      return { text: value, dim: false };
  };

  const location = formatWithFallback(jd?.job_location, "Location");
  const exp = formatWithFallback(jd?.years_of_experience, "Exp");
  const type = formatWithFallback(jd?.job_type, "Job type");
  const salary = formatWithFallback(jd?.salary_range, "Salary range");

  return (
    <>
      <AppBar
        position="sticky"
        elevation={0}
        sx={{
          backdropFilter: "blur(10px)",
          background: "rgba(255,255,255,0.9)",
          borderBottom: "1px solid #eee",
        }}
      >
        <Toolbar>
          <Typography
            variant="h6"
            fontWeight={800}
            sx={{
              background: "linear-gradient(90deg,#6366f1,#ec4899)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            ITConnectUS
          </Typography>
        </Toolbar>
      </AppBar>

      <Container maxWidth="xl" sx={{ py: 8, top: "12px" }}>
            <Box sx={{ flex: 7 }}>
              {/* <Card sx={{ p: 4, maxWidth: 1300, width: "100%" }}>

                <Typography variant="h5" gutterBottom>
                    If you are interested in this position/AI Pre-screening, 
                    please fill in the required details by clicking{" "}
                    <Button
                        variant="contained"
                        sx={{ textTransform: "none" }}
                        onClick={() => navigate(`/shortlist-details/${token}`)}
                    >
                        Here
                    </Button>
                </Typography>
        
                </Card> */}
            <Card sx={{ p: 6 }}>
                <Typography variant="h4" fontWeight={800} gutterBottom>
                {jd?.job_title || "Loading..."}
                </Typography>

                <Stack direction="row" spacing={1} flexWrap="wrap" mb={3}>
                <Chip label={`📍 ${location.text}`} sx={{ color: location.dim ? "#9e9e9e" : "#000" }} />
                <Chip label={`🧠 ${exp.text}`} sx={{ color: exp.dim ? "#9e9e9e" : "#000" }} />
                <Chip label={`💼 ${type.text}`} sx={{ color: type.dim ? "#9e9e9e" : "#000" }} />
                <Chip label={`💰 ${salary.text}`} sx={{ color: salary.dim ? "#9e9e9e" : "#000" }} />
                </Stack>

                {/* <Card sx={{ p: 4, maxWidth: 1300, width: "100%" }}> */}

                <Typography variant="h5" fontWeight={600} gutterBottom>
                    If you are interested in this position/AI Pre-screening, 
                    please fill in the required details by clicking{" "}
                    <Button
                        variant="contained"
                        sx={{ textTransform: "none" }}
                        onClick={() => navigate(`/shortlist-details/${token}`)}
                    >
                        Here
                    </Button>
                </Typography>
        
                {/* </Card> */}

                {jd?.job_summary && (
                <Box mt={4}>
                    <Typography variant="h6" fontWeight={700}>
                    About the Role
                    </Typography>
                    <ul>
                    {jd.job_summary.split("\n").map((r, i) => (
                        <li key={i}>
                        <Typography>{r}</Typography>
                        </li>
                    ))}
                    </ul>
                </Box>
                )}

                {jd?.responsibilities && (
                <>
                    <Typography variant="h6" fontWeight={700} mt={3}>
                    Responsibilities
                    </Typography>
                    <Box component="ul" sx={{ pl: 3 }}>
                    {jd.responsibilities.split("\n").map((r, i) => (
                        <li key={i}>
                        <Typography variant="body1">{r}</Typography>
                        </li>
                    ))}
                    </Box>
                </>
                )}

                {jd?.domain_requirements && (
                <>
                    <Typography variant="h6" fontWeight={700} mt={3}>
                    Doamin Requirements
                    </Typography>
                    <Box component="ul" sx={{ pl: 3 }}>
                    {jd.domain_requirements.split("\n").map((r, i) => (
                        <li key={i}>
                        <Typography variant="body1">{r}</Typography>
                        </li>
                    ))}
                    </Box>
                </>
                )}

                {jd?.required_qualifications && (
                <>
                    <Typography variant="h6" fontWeight={700} mt={3}>
                    Required Qualifications
                    </Typography>
                    <Box component="ul" sx={{ pl: 3 }}>
                    {jd.required_qualifications.split("\n").map((r, i) => (
                        <li key={i}>
                        <Typography variant="body1">{r}</Typography>
                        </li>
                    ))}
                    </Box>
                </>
                )}

                {jd?.preferred_qualifications && (
                <>
                    <Typography variant="h6" fontWeight={700} mt={3}>
                    Preferred Qualifications
                    </Typography>
                    <Box component="ul" sx={{ pl: 3 }}>
                    {jd.preferred_qualifications.split("\n").map((r, i) => (
                        <li key={i}>
                        <Typography variant="body1">{r}</Typography>
                        </li>
                    ))}
                    </Box>
                </>
                )}

                {jd?.education_qualifications && (
                <>
                    <Typography variant="h6" fontWeight={700} mt={3}>
                    Education Qualifications
                    </Typography>
                    <Box component="ul" sx={{ pl: 3 }}>
                    {jd.education_qualifications.split("\n").map((r, i) => (
                        <li key={i}>
                        <Typography variant="body1">{r}</Typography>
                        </li>
                    ))}
                    </Box>
                </>
                )}

                {jd?.certification_requirements && (
                <>
                    <Typography variant="h6" fontWeight={700} mt={3}>
                    Certification Requirements
                    </Typography>
                    <Box component="ul" sx={{ pl: 3 }}>
                    {jd.certification_requirements.split("\n").map((r, i) => (
                        <li key={i}>
                        <Typography variant="body1">{r}</Typography>
                        </li>
                    ))}
                    </Box>
                </>
                )}

                {jd?.security_clearance_requirements && (
                <>
                    <Typography variant="h6" fontWeight={700} mt={3}>
                    Security Clearance
                    </Typography>
                    <Box component="ul" sx={{ pl: 3 }}>
                    {jd.certification_requirements.split("\n").map((r, i) => (
                        <li key={i}>
                        <Typography variant="body1">{r}</Typography>
                        </li>
                    ))}
                    </Box>
                </>
                )}
            </Card>
            </Box>
            {skipping && !skipping.already_submitted && (
            <Box display="flex" justifyContent="center" mt={6}>
                {/* <Card sx={{ p: 4, maxWidth: 1200, width: "100%" }}>

                <Typography variant="h5" gutterBottom>
                    If you are interested in this position/AI Pre-screening, 
                    please fill in the required details by clicking{" "}
                    <Button
                        variant="contained"
                        sx={{ textTransform: "none" }}
                        onClick={() => navigate(`/shortlist-details/${token}`)}
                    >
                        Here
                    </Button>
                </Typography>
        
                </Card> */}
                <Dialog open={openDialog} onClose={handleClose} fullWidth>
                <DialogTitle>Schedule Your Interview</DialogTitle>
        
                <DialogContent>
                    <TextField
                    label="Preferred Date"
                    type="date"
                    fullWidth
                    margin="normal"
                    InputLabelProps={{ shrink: true }}
                    value={availability.date}
                    onChange={(e) =>
                        setAvailability({ ...availability, date: e.target.value })
                    }
                    />
        
                    <TextField
                    label="Preferred Time"
                    type="time"
                    fullWidth
                    margin="normal"
                    InputLabelProps={{ shrink: true }}
                    value={availability.time}
                    onChange={(e) =>
                        setAvailability({ ...availability, time: e.target.value })
                    }
                    />
                </DialogContent>
        
                <DialogActions>
                    <Button variant="contained" sx={{ textTransform: "none" }} onClick={handleClose}>Cancel</Button>
                    <Button variant="contained" sx={{ textTransform: "none" }} onClick={handleSubmitAvailability}>
                    Submit
                    </Button>
                </DialogActions>
                </Dialog>
            </Box>
            )}
        </Container>
        <Dialog open={openDialog} onClose={handleClose} fullWidth>
            <DialogTitle>Schedule Your Interview</DialogTitle>
    
            <DialogContent>
                <TextField
                label="Preferred Date"
                type="date"
                fullWidth
                margin="normal"
                InputLabelProps={{ shrink: true }}
                value={availability.date}
                onChange={(e) =>
                    setAvailability({ ...availability, date: e.target.value })
                }
                />
    
                <TextField
                label="Preferred Time"
                type="time"
                fullWidth
                margin="normal"
                InputLabelProps={{ shrink: true }}
                value={availability.time}
                onChange={(e) =>
                    setAvailability({ ...availability, time: e.target.value })
                }
                />
            </DialogContent>
    
            <DialogActions>
                <Button variant="contained" sx={{ textTransform: "none" }} onClick={handleClose}>Cancel</Button>
                <Button variant="contained" sx={{ textTransform: "none" }} onClick={handleSubmitAvailability}>
                Submit
                </Button>
            </DialogActions>
            </Dialog>
            <Dialog
              open={dialog.open}
              onClose={() => setDialog({ ...dialog, open: false })}
            >
              <DialogTitle sx={{ fontWeight: 700 }}>
                {dialog.title}
              </DialogTitle>
              <DialogContent>
                <Typography fontSize="14px">
                  {dialog.message}
                </Typography>
              </DialogContent>
              <DialogActions>
                <Button
                  variant="contained"
                  onClick={() => setDialog({ ...dialog, open: false })}
                >
                  OK
                </Button>
              </DialogActions>
            </Dialog>

      <Box textAlign="center" py={6} sx={{ opacity: 0.6 }}>
        <Typography variant="body2">
          © {new Date().getFullYear()} {api.app_name}. Built for the future of hiring.
        </Typography>
      </Box>
    </>
  );
}

// export default JDWithL0;